import { baseIcon } from "@/components/map/markers";
import { milesBetween } from "@/components/map/geo";

export const REGION_VIEWS = {
  "Hampton Roads": { center: [-76.33, 36.93], zoom: 9.7, pitch: 48, bearing: -14 },
  "Greater Richmond": { center: [-77.42, 37.38], zoom: 9.6, pitch: 48, bearing: -10 },
};

export const coords = (b) => `${Math.abs(b.lat).toFixed(4)}° N · ${Math.abs(b.lng).toFixed(4)}° W`;

export const BaseGlyph = ({ base, size = "h-9 w-9", selected = false }) => (
  <span
    className={`grid shrink-0 place-items-center rounded-full border-2 border-white shadow ${size} ${
      selected ? "bg-ink text-brass" : base.kind === "shipyard" ? "bg-signal text-white" : "bg-brass text-ink"
    }`}
    // static, trusted SVG strings from markers.js
    dangerouslySetInnerHTML={{ __html: baseIcon(base) }}
  />
);

/** Camera for a cinematic 3D look at an installation. */
export const baseCamera = (b, i = 0) => ({
  lng: b.lng,
  lat: b.lat,
  zoom: b.kind === "shipyard" ? 15 : 14.1,
  pitch: 64,
  bearing: [-35, 25, 60, -60, 10][i % 5],
  duration: 4200,
  curve: 1.8,
  id: `${b.id}-${Date.now()}`,
});

/** Camera framing a base and one home together so the distance line reads clearly. */
export const pairCamera = (base, home, padding) => ({
  bounds: [[Math.min(base.lng, home.lng), Math.min(base.lat, home.lat)], [Math.max(base.lng, home.lng), Math.max(base.lat, home.lat)]],
  padding,
  maxZoom: 14,
  pitch: 55,
  duration: 2200,
  id: `pair-${home.listing_key}-${Date.now()}`,
});

/** Listings within `radius` miles of a base, closest first, with `base_miles` filled in. */
export const homesNear = (base, listings, radius) =>
  listings
    .map((l) => ({ ...l, base_miles: milesBetween(l, base) }))
    .filter((l) => l.base_miles <= radius)
    .sort((a, b) => a.base_miles - b.base_miles);
